function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M24 3C10.74 3 0 11.73 0 22.5c0 4.65 2 8.9 5.34 12.25C4.17 39.48.25 43.7.21 43.73a.75.75 0 00-.14.82c.12.28.38.45.68.45 6.22 0 10.88-2.98 13.18-4.82A28.6 28.6 0 0024 42c13.26 0 24-8.73 24-19.5S37.26 3 24 3zM12 25.5a3 3 0 110-6 3 3 0 010 6zm12 0a3 3 0 110-6 3 3 0 010 6zm12 0a3 3 0 110-6 3 3 0 010 6z"
})));